import { useMutation, useQuery } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { getAssetsChargingOptions, getFutureChargingOptions, patchChargerLink } from "../api/eflow-charge-operation-planner";
export const useAssetsChargingOptions = (assets, projectId, chargeFilter, fetchChargingData, refetchDataFromApi) => {
    return useQuery({
        enabled: fetchChargingData,
        gcTime: 0,
        queryFn: async () => {
            return await getAssetsChargingOptions(assets, projectId, chargeFilter);
        },
        queryKey: ["assetsChargingOptions", assets, projectId, chargeFilter, refetchDataFromApi],
        refetchInterval: refetchApiInterval,
        retry: 1
    });
};
export const useFutureChargingOptions = (fetchFutureChargeOptions, requestBody, chargeUpto) => {
    return useQuery({
        enabled: fetchFutureChargeOptions,
        gcTime: 0,
        queryFn: async () => {
            return await getFutureChargingOptions(requestBody, chargeUpto);
        },
        queryKey: ["futureChargingOptions", requestBody, chargeUpto],
        refetchInterval: refetchApiInterval,
        retry: 1
    });
};
/**
 * Hook to update or deactivate a charger asset link
 * @returns Mutation hook for patching charger links
 */
export const usePatchChargerLink = () => {
    return useMutation({
        gcTime: 0,
        mutationFn: (chargerAssetLinkUpdateRequest) => {
            return patchChargerLink(chargerAssetLinkUpdateRequest);
        },
        retry: false
    });
};
/**
 * Alias for usePatchChargerLink - updates or deactivates a charger asset link
 * @deprecated Use usePatchChargerLink instead for consistency
 */
export const useUpdateOrDeactivateChargerLink = usePatchChargerLink;
